import { useState, useEffect } from "react";
import { PublicLayout } from "@/components/layout/PublicLayout";
import { api } from "@/lib/api";
import { Bell, Truck, ShieldCheck, DollarSign, FileWarning } from "lucide-react";

const ICONS = { load: Truck, verification: ShieldCheck, quote: DollarSign, payment: DollarSign, default: Bell };

export default function Notifications() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/notifications").then((r) => setItems(r.data)); }, []);

  const samples = [
    { type: "load", title: "NEW HOTSHOT LOAD", body: "Houston → Austin · 14 mi away · 8,200 lbs · $1,175 · $4.22/mi · XD Match 96%", sample: true },
    { type: "verification", title: "Insurance expiring", body: "Your COI expires in 30 days. Upload a renewal to stay XD Verified.", sample: true },
    { type: "payment", title: "Payment update", body: "Invoice for XD-10483 marked Paid.", sample: true },
  ];
  const all = [...items, ...samples];

  return (
    <PublicLayout>
      <section className="max-w-2xl mx-auto px-6 py-12">
        <h1 className="font-heading text-4xl font-black tracking-tight flex items-center gap-3"><Bell className="text-xd-orange" /> Notifications</h1>
        <div className="mt-8 space-y-3">
          {all.map((n, i) => {
            const Icon = ICONS[n.type] || ICONS.default;
            return (
              <div key={n.id || `s-${i}`} data-testid={`notif-${i}`} className="flex items-start gap-4 bg-xd-paper border border-xd-border rounded-xl p-4 hover:border-xd-orange/40 transition-colors">
                <span className="grid place-items-center w-10 h-10 rounded-lg bg-xd-orange/15 text-xd-orange shrink-0"><Icon size={18} /></span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <p className="font-heading font-bold text-sm">{n.title}</p>
                    {n.sample && <span className="text-[10px] uppercase font-bold text-xd-yellow">Sample</span>}
                  </div>
                  <p className="mt-0.5 text-sm text-xd-muted">{n.body}</p>
                  {n.created_at && <p className="mt-1 text-xs text-xd-dim">{new Date(n.created_at).toLocaleString()}</p>}
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </PublicLayout>
  );
}
